// src/pages/MPFlow/components/LGPDBanner.jsx
import React, { useState, useEffect } from 'react';

const LGPD_KEY = 'mp_lgpd_accepted';

export default function LGPDBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const accepted = localStorage.getItem(LGPD_KEY);
      if (!accepted) setShow(true);
    } catch {
      // localStorage indisponível
    }
  }, []);

  const accept = () => {
    try { localStorage.setItem(LGPD_KEY, '1'); } catch {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="mp-lgpd" role="banner" aria-label="Aviso de privacidade">
      <p className="mp-lgpd__text">
        <strong>Sua privacidade importa.</strong> Utilizamos dados mínimos para personalizar sua experiência
        de acordo com a <strong>LGPD</strong>. Nenhum dado sensível é salvo sem sua autorização.
      </p>
      <button className="mp-lgpd__btn" onClick={accept}>Entendi e aceito</button>
    </div>
  );
}
